/**
 * Created by neo on 26.02.17.
 */
import React, {Component} from 'react';
const FontAwesome = require('react-fontawesome');

type Props = {
  onClick: () => void,
};

export default class CloseButton extends Component {

  props: Props;


  render() {
    return (
      <div className="close-button" onClick={this.props.onClick}>
        <FontAwesome name="close" />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/App/Components/CloseButton.js